import { useState, useEffect } from 'react';

export const useGallery = (mediaItems) => {
    const [showModal, setShowModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [filter, setFilter] = useState('all');
    const [filteredItems, setFilteredItems] = useState([]);

    useEffect(() => {
        setFilteredItems(mediaItems?.filter(item =>
            filter === 'all' ? true : item.type === filter
        ));
    }, [mediaItems, filter]);

    const handlePrevious = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? filteredItems.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === filteredItems.length - 1 ? 0 : prevIndex + 1
        );
    };

    return {
        showModal,
        setShowModal,
        currentIndex,
        setCurrentIndex,
        filter,
        setFilter,
        filteredItems,
        handlePrevious,
        handleNext
    };
};